import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-345c8b9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "login" }
const _hoisted_2 = {
  key: 0,
  class: "wrap flex-cen login_page"
}
const _hoisted_3 = { class: "login-rt" }

import { ref, onMounted, Prop, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import LoginForm from '@/components/Login/index.vue'
import LoginIntroduce from './components/LoginIntroduce.vue'
import Header from './components/header.vue'
import ContactModal from './components/ContactModal.vue'
import { getUser, registerPageImageQuery } from '@/apis/login'
import { isEN, isJA, isKO, useSite2Station } from '@/store'
import { CountriesEnum, PlatProps, Site, UseType } from '@/common/const'
import { t } from '@/plugins/i18n'
interface registerPageImageQueryRsp {
  success: boolean;
  msg: string;
  code: string;
  data: {
    stationCode: Site;
    imageUrl: string;
    jumpUrl: string
  };
}


export default /*#__PURE__*/_defineComponent({
  props: ['h5'],
  setup(__props) {



const store = useStore()
const router = useRouter()
const route = useRoute()
const clientHeight = ref(550)

const stationCode = useSite2Station()
const defaultImgUrl =
  'https://ckbs-static.theckbs.com/client-static/login/login_bg.png'
const IgmUrl = ref(defaultImgUrl)

const redirectToH5 = () => {
  if (window.screen?.availWidth < 700 && route.path !== '/login/findpwd') {
    router.replace('/login_h5')
  }
}
onMounted(async () => {
  window?.ECHAT?.closeMiniChat({ directClose: 1 })
  clientHeight.value = document.body.clientHeight
  const rsp = await registerPageImageQuery<
    { stationCode: Site },
    registerPageImageQueryRsp
  >({ stationCode })
  IgmUrl.value = rsp?.data?.imageUrl || defaultImgUrl
  redirectToH5()
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header),
    (!_unref(route).path.includes('/login/findpwd'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(LoginIntroduce),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(LoginForm, { h5: false })
          ]),
          _createVNode(ContactModal)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, {
          "enter-active-class": "animated fadeIn",
          "leave-active-class": "animated fadeOut"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    })
  ]))
}
}

})